import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';

/**
 * This utility appends the additional properties to the item response shape
 * @param initialResponseShape
 * @param additionalProperties
 */
export const itemResponseShapeWithAdditionalProperties = (
    initialResponseShape: Partial<ItemResponseShape>,
    ...additionalProperties: string[]
) =>
    itemResponseShape({
        ...initialResponseShape,
        AdditionalProperties: [
            ...(initialResponseShape?.AdditionalProperties || []),
            ...additionalProperties.sort().map(property => propertyUri({ FieldURI: property })),
        ],
    });
